<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="professional_header">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <div class="professional_heading">
                        <h1>エナゴの英文校正サービス</h1>
                        <img src="assets/images/proofreaional_poweredby_img.png" alt="powered-by-left">
                    </div>
                    <div class="professional_contents">
                        <p>Trinkaは、論文から英文・英語のミスを取り除くのに役立ちます。論文を出版するには、<br class="removeBr" />言語のミスをなくすことが重要です。ジャーナルは採択の可否を決定する際、<br class="removeBr" />論文の論理性、科学的根拠、確実な方法論などをチェックします。</p>
                        <p>Trinkaのプラットフォームからは、エナゴが提供する専門家による英文校正サービスを簡単にご依頼いただくことができます。エナゴの英文校正サービスは、綴りや文法の修正にはとどまりません。お預かりした論文は、同じ分野の専門家により、論理的な流れ、<br class="removeBr" />全体の構成、ジャーナル・ガイドラインとの整合性などの観点から校正されます。また、投稿前に本番と同様の査読を行う「プレ査読」というサービスも提供しています。</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="professional_img">
                        <img src="assets/images/searching_for_proofreading.png" alt="英文校正">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="profressional_pricing">
        <div class="profressional_pricing_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="profressional_cards">
                        <div class="prof_card_heading">
                            <h2><img src="assets/images/Proofreading_icons.png" alt="icon"> プルーフリーディング／シングルチェック</h2>
                            <p>ジャーナルへの投稿前に、論文の英語文法と表記スタイルの整合性を確認したい、<br class="removeBr" />という方におすすめ。</p>
                        </div>
                        <div class="prof_card_bodysection">
                            <ul>
                                <li>文法と構文の修正</li>
                                <li>句読点のチェック</li>
                                <li>スペルと時制のチェック</li>
                                <li>文体と一貫性のチェック</li>
                                <li>対象原稿と専門分野の合致する英語ネイティブの校正者1名</li>
                                <li>納品後1年間の無料Q&A</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 paddingSectionRemove">
                    <div class="profressional_cards">
                        <div class="prof_card_heading">
                            <h2><img src="assets/images/CopyEditing_Icon.png" style="width: 40px;" alt="editing"> ノーマル英文校正</h2>
                            <p>文章レベルで質の高い英文校正をお求めの方におすすめ。徹底的な文法チェックで言語的な正確さを高め、表現に切れ味を与えて文章の読みやすさを高めます。</p>
                        </div>
                        <div class="prof_card_bodysection">
                            <div class="additional_services">
                                <p><img src="assets/images/Proofreading_icons.png" alt="英文校正" style="width: 20px;"> プルーフリーディングの全項目</p>
                                <span><i class="fa fa-plus"></i></span>
                            </div>
                            <ul>
                                <li>明瞭さや読みやすさの観点からの英語チェック</li>
                                <li>高度な文法チェック</li>
                                <li>適切な単語・語句への置き換え</li>
                                <li>構文チェック</li>
                                <li>ジャーナルの投稿規程に合わせたフォーマット調整</li>
                                <li>10%の単語削減</li>
                                <li>専門分野と学術英語のライティングを熟知した2名の校正者</li>
                                <li>1ページにまとめた原稿評価カルテ 
                                    <span class="prof_tooltipSection">
                                        <img src="assets/images/info.svg" alt="icon">
                                    </span>
                                    <div class="tooltiptext_section CopyEditingSection">
                                        <p>お客様の書かれた英語の質をコメント付きで評価するレポート</p>
                                    </div>
                                </li>
                                <li>120日間の無制限再校正* 
                                    <span class="prof_tooltipSection"><img src="assets/images/info.svg" alt="icon"></span>
                                    <div class="tooltiptext_section 数無制限Tooltip">
                                        <p>納品後にお客様が修正された原稿を回数無制限で再校正する修正保証制度</p>
                                        <img src="assets/images/PaperIcons.png" alt="icon">
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="profressional_cards">
                        <div class="prof_card_heading">
                            <h2> <img src="assets/images/SubstantiveEditing_Icon.png"  style="width: 40px;" alt="editing"> アドバンス英文校正</h2>
                            <p>論文全体の流れにまで踏み込んだ英文校正をお求めの方におすすめ。文法ミスや専門用語のチェック・修正にとどまらず、論旨の展開や内容の妥当性にまで踏み込み分析し、より説得力のある英文を提案します。</p>
                        </div>
                        <div class="prof_card_bodysection">
                            <div class="additional_services">
                                <p><img src="assets/images/CopyEditing_Icon.png" style="width: 30px;" alt="editing"> ノーマル英文校正の全項目</p>
                                <span><i class="fa fa-plus"></i></span>
                            </div>
                            <ul>
                                <li>内容に踏み込んだ改善の提案</li>
                                <li>専門性に即した校正</li>
                                <li>論旨展開のチェック</li>
                                <li>論文の構造のチェック</li>
                                <li>ジャーナルの投稿規程に合わせたフォーマット調整</li>
                                <li>20%の単語削減</li>
                                <li>無料カバーレター</li>
                                <li>4ページにわたる詳細な原稿評価カルテ 
                                    <span class="prof_tooltipSection"><img src="assets/images/info.svg" alt="icon"></span>
                                    <div class="tooltiptext_section SubstantiveSection">
                                        <p>お客様の書かれた英語の質をコメント付きで評価するレポート</p>
                                    </div>                                
                                </li>
                                <li>365日間の無制限再校正 <span class="prof_tooltipSection"><img src="assets/images/info.svg" alt="icon"></span>
                                    <div class="tooltiptext_section secondTooltip">
                                        <p>納品後にお客様が修正された原稿を回数無制限で再校正する修正保証制度</p>
                                        <img src="assets/images/PaperIcons.png" alt="icon">
                                    </div>
                                </li>
                                <li>
                                    365日間の査読対応オプション* <span class="prof_tooltipSection"><img src="assets/images/info.svg" alt="icon"></span>
                                    <div class="tooltiptext_section thiredTooltip">
                                        <p>オリジナル原稿を校正した専門家2名が、お客様が査読者コメントに沿って修正された原稿を回数無制限で再校正</p>
                                        <img src="assets/images/Rejections_Shield.png" alt="shield" style="margin-left: -20px;">
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="paidSection">
                        <p>*有料オプション</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>